export default __webpack_public_path__ + "static/media/download.a3498030.svg";